// @flow
import { handleResponseOld, makeDelete, makeGet, makePatch, makePost } from './helpers';

type FetchConversationFoldersParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    limit?: boolean,
};

export default {
    deleteArchiveConversationFolders: ({ authToken, bidderId, deployment, folderId }: Object) =>
        new Promise<any>((resolve, reject) => {
            const request = makeDelete({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/folders?folderId=${folderId}`,
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchConversationFolders: ({ authToken, bidderId, deployment, limit = false }: FetchConversationFoldersParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/folders`,
            });
            request.query({ userFolderLimit: 200 });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    patchRenameConversationFolders: ({ authToken, bidderId, deployment, folderId, name }: Object) =>
        new Promise<any>((resolve, reject) => {
            const request = makePatch({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/folders`,
            });
            request.send({ id: folderId, name });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postNewConversationFolders: ({ authToken, bidderId, deployment, name }: Object) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/folders`,
            });
            request.send({ name });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
